import Quill from 'quill';

const ImageBlot = Quill.import('formats/image');
const ImageFormatAttributesList = ['alt', 'height', 'width', 'style'];
const AnchorStyle = [
  'pointer-events: auto;',
  'display: inline-block;',
  'width: fit-content;',
];

// Keeping the width and style in the blot's value to make it easier to "blot.replaceWith('inline-image', value, 'user')" in the
// code otherwise you have to reapply the style and it's awkward.
class InlineImageBlot extends ImageBlot {
  static blotName = 'inline-image';
  static tagName = 'IMG';
  static className = 'inline-image-blot';

  static formats(domNode) {
    return ImageFormatAttributesList.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);

        return formats;
      }

      if (domNode.tagName === 'A') {
        const imgNode = domNode.firstChild;

        if (imgNode.hasAttribute(attribute)) {
          formats[attribute] = imgNode.getAttribute(attribute);
        }
      }

      return formats;
    }, {});
  }

  // Create HTML node
  static create(value) {
    const node = super.create();

    node.setAttribute('src', value.src);
    node.setAttribute('id', value.id);
    node.setAttribute('width', value.width);

    if (value.link) {
      const anchor = document.createElement('a');

      anchor.setAttribute(
        'style',
        `${AnchorStyle.join(' ')} ${value.style ?? ''}`,
      );

      anchor.href = value.link;
      anchor.appendChild(node);
      anchor.className = InlineImageBlot.className;

      return anchor;
    }

    node.setAttribute('style', value.style);

    return node;
  }

  // Convert HTML node to value
  static value(node) {
    const blot = {};

    // Get the style of the root node (either A or IMG)
    const style = node.getAttribute('style');

    blot.style =
      style &&
      AnchorStyle.reduce(
        (cleanedStyle, item) => cleanedStyle.replace(item, ''),
        style,
      );

    let imgNode = node;

    if (node.tagName === 'A') {
      blot.link = node.getAttribute('href');
      imgNode = node.firstChild;
    }

    blot.src = imgNode.getAttribute('src');
    blot.id = imgNode.getAttribute('id');
    blot.width = imgNode.getAttribute('width');

    return blot;
  }

  format(name, value) {
    const imgNode =
      this.domNode.tagName === 'A' ? this.domNode.firstChild : this.domNode;

    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        if (name === 'width') {
          imgNode.setAttribute(name, value);
        } else {
          this.domNode.setAttribute(name, value);
        }
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  getUrl() {
    return this.domNode.href ?? '';
  }
}

export default InlineImageBlot;
